<span
  [ngbPopover]="CommentPopContent"
  placement="bottom-left"
  *ngIf="type === 'ESAS'"
  triggers="manual"
  autoClose="outside"
  #p2="ngbPopover"
  (click)="toggleWithCommentContext(p2)"
>
  <a class="link link--dotted-blue-dark">Добавить</a>
</span>

<ng-template #CommentPopContent>
  <app-loader *ngIf="ticketCommentLoading"></app-loader>
  <div class="w-320">
    <app-field>
      <label
        ><span class="title title--s title--required">Комментарий в {{ Enums.projectName }}</span></label
      >
      <textarea class="input-textarea" id="appAddComment" cols="45" rows="6" [(ngModel)]="comment"></textarea>
    </app-field>
    <div *ngIf="ticketCommentError" class="mt-16">
      <app-message [type]="'error'">
        <div message-content>{{ ticketCommentError }}</div>
      </app-message>
    </div>
    <div class="mt-24">
      <button class="button" type="button" (click)="onAddComment()" [disabled]="!comment">Готово</button>
    </div>
  </div>
</ng-template>
